import { WSService } from "../../../utils/WSService";
import type { bankingApiSpec } from "@wingspanhq/wingspan-api-types";

const service = new WSService("/v2/banking/internal-accounts");

export const listInternalAccounts = async (
  type?: "Clearing" | "TaxWithholding" | "Banking" | "InternationalClearing"
): Promise<
  bankingApiSpec.operations["listInternalAccounts"]["responses"]["200"]["content"]["application/json"]
> => {
  const { data } = await service.get("", {
    params: {
      type
    }
  });
  return data;
};

export const createInternalAccount = async (
  request: bankingApiSpec.operations["createInternalAccount"]["requestBody"]["content"]["application/json"]
): Promise<
  bankingApiSpec.operations["createInternalAccount"]["responses"]["200"]["content"]["application/json"]
> => {
  const { data } = await service.post("", request);
  return data;
};

export const getInternalAccount = async (
  internalAccountId: string
): Promise<
  bankingApiSpec.operations["getInternalAccount"]["responses"]["200"]["content"]["application/json"]
> => {
  const { data } = await service.get("/" + internalAccountId);
  return data;
};

export const getInternalAccountBalance = async (
  internalAccountId: string
): Promise<
  bankingApiSpec.operations["getInternalAccountBalance"]["responses"]["200"]["content"]["application/json"]
> => {
  const { data } = await service.get("/" + internalAccountId + "/balance");
  return data;
};

export const listInternalAccountTransactions = async (
  internalAccountId: string,
  query?: bankingApiSpec.operations["listInternalAccountTransactions"]["parameters"]["query"]
): Promise<
  bankingApiSpec.operations["listInternalAccountTransactions"]["responses"]["200"]["content"]["application/json"]
> => {
  const { data } = await service.get(
    "/" + internalAccountId + "/transactions",
    { params: query }
  );
  return data;
};

export const createInternalAccountTransfer = async (
  internalAccountId: string,
  request: bankingApiSpec.operations["createInternalAccountTransfer"]["requestBody"]["content"]["application/json"]
): Promise<
  bankingApiSpec.operations["createInternalAccountTransfer"]["responses"]["200"]["content"]["application/json"]
> => {
  const { data } = await service.post(
    "/" + internalAccountId + "/transfers",
    request
  );
  return data;
};
